import moment from 'moment';
import get from 'lodash/get';
import isString from 'lodash/isString';
import featureNames from '@utils/featureToggle/constants';
import { CONTEXT_MAP, INVERT_CONTEXT_MAP } from './constants';

export const checkIfStreamMetaAccountEnabled = () => {
  const state = window.store ? window.store.getState() : {};
  const features = get(state, 'common.features', {});
  return features[featureNames.STREAM_METADATA_ACCOUNT];
};

export const renameAllShortInAString = (data) => {
  if (!checkIfStreamMetaAccountEnabled()) return data;
  ['VPF', 'VRT', 'VSF', 'VST', 'EBVS'].forEach((short) => {
    data = data.replaceAll(short, renameShort(short));
  });
  return data;
};

export const renameVideoToStream = (data) => {
  if (!data) {
    return '';
  }
  if (!checkIfStreamMetaAccountEnabled()) return data;
  const processedData = JSON.stringify(data)
    .replaceAll('Video', 'Stream')
    .replaceAll('video', 'stream');
  return JSON.parse(processedData);
};

export const renameShort = (shortName) => {
  if (!checkIfStreamMetaAccountEnabled()) return shortName;
  const shortNames = {
    VPF: 'SPF',
    'VPF-B': 'SPF-B',
    'VPF-T': 'SPF-T',
    'VPF-T ADS': 'SPF-T ADS',
    VRT: 'SRT',
    VSF: 'SSF',
    'VSF-B': 'SSF-B',
    'VSF-T': 'SSF-T',
    VST: 'SST',
    EBVS: 'EBSS',
  };
  return shortNames[shortName] ? shortNames[shortName] : shortName;
};

export interface Annotation {
  cause: string;
  type: 'intervalAlignment' | 'realtimeIntervalAlignment';
  /**
   * for example: "2024-07-02T05:18:00+01:00/2024-07-02T11:18:17+01:00"
   */
  value: string;
}
export function getEndTimeOfIntervalAnnotation(
  annotations: Annotation[],
  key: string | string[],
): string | null {
  key = (Array.isArray(key) ? key : [key]) as string[];
  const annotation = (annotations ?? []).find((it) => key.includes(it.type));
  if (!annotation) {
    return null;
  }
  const { value } = annotation;
  if (!isString(value)) {
    return null;
  }
  const [, end] = value.split('/');
  if (!isString(end)) {
    return null;
  }
  if (!moment(end).isValid()) {
    return null;
  }
  return end;
}

export const getInvertContextMap = (context: string) => {
  return INVERT_CONTEXT_MAP[context] || context.toLowerCase();
};

export const getContextMap = (context: string) => {
  return CONTEXT_MAP[context] || context.toUpperCase();
};
